import script from "./detailView.vue?vue&type=script&setup=true&lang=js"
export * from "./detailView.vue?vue&type=script&setup=true&lang=js"

import "./detailView.vue?vue&type=style&index=0&id=1a63b7ad&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a63b7ad"]])

export default __exports__